import script from "./logout-button.vue?vue&type=script&setup=true&lang=js"
export * from "./logout-button.vue?vue&type=script&setup=true&lang=js"

import "./logout-button.vue?vue&type=style&index=0&id=db15ed50&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db15ed50"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
